// extracted by mini-css-extract-plugin
module.exports = {"message":"ConfirmCode_message__2tFs7","send":"ConfirmCode_send__3ne33"};